import * as React from "react";
import Menu from "@material-ui/core/Menu";
import { Button } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Input from "@material-ui/core/Input";
import FormHelperText from "@material-ui/core/FormHelperText";
import SearchClauseInput from "./SearchClauseInput";
import TextField from "@material-ui/core/TextField";

const styles = theme => ({
  valueFormControl: {
    margin: theme.spacing(1),
    minWidth: 280
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 280,
    display: "block"
  },
  border: {
    border: "1px dashed #D50032"
  }
});

class SearchClauseForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      open: false
    };
  }

  handleClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
      open: true
    });
  }

  handleClose() {
    this.setState({
      anchorEl: null,
      open: false
    });

    // refresh search
  }

  render() {
    const {
      clause,
      clauseIdx,
      classes,
      pitsMetadataStore,
      canDelete,
      onSave,
      onDelete,
      label
    } = this.props;

    const isGameDate = clause.fieldName === "GameDate";

    return (
      <div style={{ display: "flex" }}>
        <Button
          aria-label="more"
          onClick={e => this.handleClick(e)}
          variant={"contained"}
          style={{ fontSize: "0.75rem", marginRight: "0.5rem" }}
          color={clauseIdx >= 0 ? "primary" : "default"}
        >
          {label}
        </Button>
        <Menu
          id="long-menu"
          MenuListProps={{
            "aria-labelledby": "long-button"
          }}
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={() => this.handleClose()}
          PaperProps={{
            style: {
              padding: "8px",
              overflow: "visible"
            }
          }}
        >
          <div>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="category">Category</InputLabel>
              <Select
                fullWidth
                value={clause.category}
                onChange={e => {
                  clause.resetFieldData();
                  clause.resetType();
                  clause.resetOperator();
                  clause.resetValue();
                  clause.resetValues();
                  clause.category = e.target.value;
                }}
                inputProps={{
                  name: "Category",
                  id: "category"
                }}
              >
                {pitsMetadataStore.categories.map((c, i) => (
                  <MenuItem key={i} value={c.value}>
                    {c.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              className={classes.formControl}
              disabled={clause.isFieldNameDisabled}
            >
              <InputLabel htmlFor="field-name">Subcategory</InputLabel>
              <Select
                fullWidth
                value={clause.fieldId === -1 ? "" : clause.fieldId}
                onChange={e => {
                  clause.resetOperator();
                  clause.resetValue();
                  clause.resetValues();
                  clause.fieldId = e.target.value;
                  clause.fieldName =
                    pitsMetadataStore.fields[e.target.value].name;
                  clause.type = pitsMetadataStore.fields[e.target.value].type;
                  clause.fieldHelperText =
                    pitsMetadataStore.fields[e.target.value].helperText;
                  clause.operator =
                    pitsMetadataStore.fields[e.target.value].defaultOperator;
                }}
                input={<Input name="Field Name" id="field-name" />}
              >
                {!clause.isFieldNameDisabled &&
                  pitsMetadataStore.fieldsByCategory[
                    clause.category.toUpperCase()
                  ].map((field, i) => (
                    <MenuItem key={i} value={Number(field.id)}>
                      {field.displayName}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <FormControl
              className={classes.formControl}
              disabled={clause.isOperatorDisabled}
              error={clause.hasOperatorErrors}
            >
              <InputLabel htmlFor="operator">Operator</InputLabel>
              <Select
                fullWidth
                value={clause.operator}
                onChange={e => (clause.operator = e.target.value)}
                input={<Input name="Operator" id="operator" />}
              >
                {!clause.isOperatorDisabled &&
                  pitsMetadataStore.typesByName[
                    pitsMetadataStore.fields[clause.fieldId].type
                  ].supportedComparators.map((comparator, i) => (
                    <MenuItem key={i} value={comparator.symbol}>
                      {comparator.displayName}
                    </MenuItem>
                  ))}
              </Select>
              {clause.hasOperatorErrors ? (
                <FormHelperText>{clause.operatorErrorMessage}</FormHelperText>
              ) : null}
            </FormControl>
            <FormControl
              className={classes.valueFormControl}
              error={clause.hasValuesErrors}
            >
              {pitsMetadataStore.fieldsWithDistinctValues.includes(
                clause.fieldName
              ) ? (
                <SearchClauseInput clause={clause} clauseIdx={clauseIdx} />
              ) : (
                <TextField
                  id="value"
                  label="Value"
                  fullWidth
                  className={classes.input}
                  error={clause.hasValueErrors}
                  value={clause.value}
                  type={isGameDate ? "date" : null}
                  onKeyDown={e => e.stopPropagation()}
                  helperText={
                    clause.hasValueErrors
                      ? clause.valueErrorMessage
                      : clause.fieldHelperText
                  }
                  InputLabelProps={{
                    shrink: isGameDate || clause.value !== ""
                  }}
                  disabled={
                    clause.isFieldNameDisabled || clause.isOperatorDisabled
                  }
                  onChange={e => (clause.value = e.target.value)}
                />
              )}
            </FormControl>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "1rem"
              }}
            >
              <Button
                size={"small"}
                className={classes.button}
                aria-label="Delete"
                variant={"contained"}
                disabled={!canDelete}
                color={"secondary"}
                onClick={() => {
                  onDelete && onDelete(clauseIdx);
                  this.handleClose();
                }}
              >
                Delete
              </Button>
              <Button
                size={"small"}
                className={classes.button}
                variant={"contained"}
                disabled={!clause.isComplete}
                color={"primary"}
                onClick={e => {
                  onSave && onSave(clause);
                  this.handleClose();
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </Menu>

        {clause.hasNext && (
          <Button
            aria-label="more"
            onClick={() => {
              clause.logicalConjunctionOperator =
                clause.logicalConjunctionOperator === "AND" ? "OR" : "AND";
              onSave && onSave();
            }}
            style={{
              fontSize: "0.75rem",
              marginRight: "0.5rem",
              height: "100%",
              minWidth: "32px",
              padding: "0"
            }}
            color={"default"}
          >
            {clause.logicalConjunctionOperator}
          </Button>
        )}
      </div>
    );
  }
}

export default inject("pitsMetadataStore")(
  withStyles(styles)(observer(SearchClauseForm))
);



// WEBPACK FOOTER //
// ./src/components/SearchClauseForm.js